<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bMFvGA/tc-custom/9783958648401_IMGJPG_FrontCover_0.jpg" alt="This image is the cover for the book Linnet: A Romance, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Linnet: A Romance, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>"Linnet" is a classic romance novel by noted author Grant Allen</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Grant Allan
      </h2>
      
      <p class="authorDescription body article">Charles Grant Blairfindie Allen (February 24, 1848 – October 25, 1899) was a Canadian science writer and novelist, and a proponent of the theory of evolution. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?838f2d2c